/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_SkipInputs */

const en_mk_skip = /** @type {(inputs: Mk_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to content`)
};

const id_mk_skip = /** @type {(inputs: Mk_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung ke konten`)
};

/**
* | output |
* | --- |
* | "Skip to content" |
*
* @param {Mk_SkipInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_skip = /** @type {((inputs?: Mk_SkipInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_SkipInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_skip(inputs)
	return en_mk_skip(inputs)
});